// extracted by mini-css-extract-plugin
export default {"wrapper":"currentRated_wrapper__aQ3bo","countRate":"currentRated_countRate__tKea7","listRate":"currentRated_listRate__Dtsjv","countRate_title":"currentRated_countRate_title__zOl7f"};